import { render } from "./tradeOfferReview.vue?vue&type=template&id=dd6830da&scoped=true"
import script from "./tradeOfferReview.vue?vue&type=script&lang=js"
export * from "./tradeOfferReview.vue?vue&type=script&lang=js"

import "./tradeOfferReview.vue?vue&type=style&index=0&id=dd6830da&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6830da"]])

export default __exports__